import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDialog } from '../../../core/actions';
import ModalDialog from '../../../core/components/Modal';
import { DEFAULT_ESTIMATES_COUNT } from '../models';

// Shown when a claim moves to Estimates Required. The guest is asked for estimates from shops of
// their choice, or is sent the designated repair shop email naming the shop and its address.
export const EstimatesRequiredDialog = ({ isOpen, closeDialog, onSubmit, canComposeEmail }) => {
  const [hasDesignatedShop, setHasDesignatedShop] = useState(false);
  const [repairShopName, setRepairShopName] = useState('');
  const [repairShopAddress, setRepairShopAddress] = useState('');
  const [estimatesCount, setEstimatesCount] = useState(`${DEFAULT_ESTIMATES_COUNT}`);
  const parsedCount = parseInt(estimatesCount, 10);
  const isValid = hasDesignatedShop
    ? !!repairShopName.trim() && !!repairShopAddress.trim()
    : Number.isInteger(parsedCount) && parsedCount > 0;

  const handleReady = () => {
    closeDialog();
    onSubmit({
      designatedRepairShop: hasDesignatedShop
        ? { name: repairShopName.trim(), address: repairShopAddress.trim() }
        : null,
      estimatesCount: hasDesignatedShop ? 1 : parsedCount,
    });
  };

  return (
    <ModalDialog
      title="Estimates Required"
      isOpen={isOpen}
      close={closeDialog}
      onReady={handleReady}
      submitButtonText="Continue"
      disabled={!isValid}
    >
      <div className="form-check">
        <label className="form-check-label" htmlFor="hasDesignatedShop">
          <input
            id="hasDesignatedShop"
            className="form-check-input"
            type="checkbox"
            checked={hasDesignatedShop}
            disabled={!canComposeEmail}
            onChange={(event) => setHasDesignatedShop(event.target.checked)}
          />{' '}
          We have a designated repair shop
        </label>
      </div>
      {hasDesignatedShop ? (
        <div className="form-group mt-3">
          <label htmlFor="repairShopName">Repair shop name</label>
          <input
            id="repairShopName"
            className="form-control"
            type="text"
            value={repairShopName}
            onChange={(event) => setRepairShopName(event.target.value)}
          />
          <label className="mt-3" htmlFor="repairShopAddress">
            Repair shop address
          </label>
          <input
            id="repairShopAddress"
            className="form-control"
            type="text"
            value={repairShopAddress}
            onChange={(event) => setRepairShopAddress(event.target.value)}
          />
          <small className="form-text text-muted">
            The guest is emailed the designated repair shop&apos;s name and address.
          </small>
        </div>
      ) : (
        <div className="form-group mt-3">
          <label htmlFor="estimatesCount">Number of estimates</label>
          <input
            id="estimatesCount"
            className="form-control"
            type="number"
            min={1}
            value={estimatesCount}
            disabled={!canComposeEmail}
            onChange={(event) => setEstimatesCount(event.target.value)}
          />
          <small className="form-text text-muted">
            The guest is emailed asking for this many repair estimates.
          </small>
        </div>
      )}
      {!canComposeEmail && (
        <p className="mt-3 mb-0 text-muted">
          Only users who can compose claim emails can change these options.
        </p>
      )}
    </ModalDialog>
  );
};

EstimatesRequiredDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  canComposeEmail: PropTypes.bool,
};

EstimatesRequiredDialog.defaultProps = {
  canComposeEmail: true,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ closeDialog: hideDialog }, dispatch);

export default connect(null, mapDispatchToProps)(EstimatesRequiredDialog);
